export interface DailyBusinessHours {
  open: string
  close: string
  closed: boolean
}

export const defaultBusinessHours = {
  Monday: { open: '9:00 AM', close: '5:00 PM', closed: false },
  Tuesday: { open: '9:00 AM', close: '5:00 PM', closed: false },
  Wednesday: { open: '9:00 AM', close: '5:00 PM', closed: false },
  Thursday: { open: '9:00 AM', close: '5:00 PM', closed: false },
  Friday: { open: '9:00 AM', close: '5:00 PM', closed: false },
  Saturday: { open: '9:00 AM', close: '5:00 PM', closed: true },
  Sunday: { open: '9:00 AM', close: '5:00 PM', closed: true },
}

export const testBusinessHours = {
  Monday: { open: '7:00 AM', close: '2:00 PM', closed: false },
  Tuesday: { open: '9:00 AM', close: '6:00 PM', closed: false },
  Wednesday: { open: '8:00 AM', close: '4:30 PM', closed: false },
  Thursday: { open: '9:00 AM', close: '5:00 PM', closed: true },
  Friday: { open: '9:00 AM', close: '5:00 PM', closed: true },
  Saturday: { open: '9:00 AM', close: '5:00 PM', closed: true },
  Sunday: { open: '9:00 AM', close: '5:00 PM', closed: true },
}
